import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Paper, Button, Typography, Fade } from '@mui/material';
import ContactFormDialog from './ContactFormDialog';

import tankScene from '../assets/images/tank-scene.jpg'

const ContactContainer = styled(Grid)(({ theme }) => ({
  background:'#003057',
  marginTop:theme.spacing(3),
}));

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: 'transparent',
  textAlign: 'left !important',
  color: '#FFF'
}));

const ContactUs = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <Fade
      in={true}
      style={{ transformOrigin: 'center right' }}
      {...(true ? { timeout: 1000 } : {})}
    >
      <ContactContainer container item xs={12}>
        <Grid item xs={12} lg={6} order={{ xs: 2, lg: 1 }}>
          <Item>
            <Typography style={{ color: '#FFF', lineHeight: '35px' }} variant="h2" component="h2">
              Would you like to compare full life cycle costs with different materials?
            </Typography>
            <Typography style={{color:'#FFF', fontSize: '16px', lineHeight:'21px'}} variant="p" component="p">
              Get a full scale view to your tank project with our advanced Tankbuilder calculation tool. You can compare full life cycle costs with up to four different steel grade options that you specify, covering everything:
            </Typography>
            
            <ul style={{fontFamily: 'TeeFranklinForeverBook', color:'#FFF', fontSize: '16px', lineHeight:'21px'}}>
              <li>Material costs</li>
              <li>Welding</li>
              <li>Assembly</li>
              <li>Surface treatment</li>
            </ul>

            <Typography style={{marginTop: '40px', color:'#FFF', fontSize: '26px', lineHeight:'32px'}} variant="p" component="p">  
              Would you like to discuss with an expert to learn more?
            </Typography>
            <Button
            style={{ margin:0 }}
            onClick={()=> {
              setOpen(true);
              
              /* eslint-disable */
              if(parent && parent.dataLayer) {
                parent.dataLayer.push({
                  'event': 'StorageTankClickContactUsBtn'
                });
              }
              /* eslint-enable */
            }}

            variant="contained">
              Yes, contact me
            </Button>
          </Item>
        </Grid>

        <Grid item xs={12} lg={6} order={{ xs: 1, lg: 2 }} sx={{paddingBottom: { xs: '70%' }}} style={{background: `url(${ tankScene })`, backgroundSize: 'cover'}}>
        </Grid>
        <ContactFormDialog id={'contact-form-dialogue'} open={open} handleClose={() => setOpen(false)} /> 
      </ContactContainer>
    </Fade>
  );
}

export default ContactUs;
